import {
  Box,
  Table,
  Thead,
  Tbody,
  Th,
  Tr,
  Td,
  Flex,
  IconButton,
  Link as ChakraLink,
} from "@chakra-ui/react";
import {
  LanguageOptions,
  SortOrder,
  useCategoriesQuery,
  useDeleteCategoryMutation,
} from "../../generated/graphql";
import { FcRefresh, FcPlus, FcEditImage } from "react-icons/fc";
import DeleteItem from "../../components/delete/DeleteItem";
import Loading from "../../components/loading/Loading";
import Error from "../../components/error/Error";
import PageLayout from "../../components/ui/PageLayout";
import { Link } from "react-router-dom";
import { IoMdReorder } from "react-icons/io";
import Description from "../../components/description/Description";

interface Props {
  parentId?: string;
}

const All: React.VFC<Props> = ({ parentId }) => {
  const [deleteCategory] = useDeleteCategoryMutation();

  const { loading, error, data, refetch } = useCategoriesQuery({
    variables: {
      orderBy: {
        order: SortOrder.asc,
      },
      where: {
        ...(parentId
          ? { parentId: { equals: parentId } }
          : { parentId: { equals: null } }),
      },
    },
    fetchPolicy: "network-only",
  });
  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Error />;
  }

  const handleDelete = async (id: string) => {
    try {
      await deleteCategory({
        variables: {
          where: {
            id,
          },
        },
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <PageLayout>
      <Flex
        mb={6}
        justifyContent={"space-between"}
        alignItems="center"
        bgColor={"gray.100"}
        padding={2}
        rounded="md"
      >
        <Box fontSize={"18px"} fontWeight="bold">
          Category List
        </Box>
        <Flex experimental_spaceX={4}>
          <IconButton
            to={`/category/order/${parentId ? parentId : ""}`}
            as={Link}
            icon={<IoMdReorder fontSize="24px" />}
            aria-label="Order"
            onClick={() => refetch()}
          />
          <IconButton
            icon={<FcRefresh />}
            aria-label="Refetch Query"
            onClick={() => refetch()}
          />
          <IconButton
            to={`/category/create`}
            as={Link}
            icon={<FcPlus />}
            aria-label="Add Item"
            onClick={() => refetch()}
          />
        </Flex>
      </Flex>
      <Table>
        <Thead>
          <Tr>
            <Th>#</Th>
            <Th>Photo</Th>
            <Th>Title</Th>
            <Th>Subcategory Count</Th>

            <Th textAlign={"center"}>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data?.categories.map((category, i) => {
            return (
              <Tr key={i}>
                <Td>{i + 1}</Td>
                <Td width={"170px"}>
                  <img
                    src={`${process.env.REACT_APP_CDN}thumbs/${category.photos[0]}`}
                    alt="Category"
                  />
                </Td>
                <Td>
                  <Description
                    field="category"
                    id={category.id}
                    descriptions={category.descriptions}
                    refetch={refetch}
                  />
                </Td>

                <Td>
                  <ChakraLink as={Link} to={`/category/${category.id}`}>
                    {category._count?.subCategories}
                  </ChakraLink>
                </Td>

                <Td>
                  <Flex justifyContent={"center"}>
                    <Box mx={2}>
                      <IconButton
                        aria-label="Edit"
                        icon={<FcEditImage />}
                        as={Link}
                        to={`/category/update/${category.id}`}
                      />
                    </Box>
                    <Box mx={2}>
                      <DeleteItem
                        id={category.id}
                        refetch={refetch}
                        title={`${
                          category.descriptions.find(
                            (d) => d.language === LanguageOptions.EN
                          )?.title
                        }`}
                        handleDelete={handleDelete}
                      />
                    </Box>
                  </Flex>
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </PageLayout>
  );
};

export default All;
